module.exports = __webpack_public_path__ + "static/media/halloween12.e9f59487.jpg";